"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyResultsResponseToJSON = exports.SurveyResultsResponseFromJSONTyped = exports.SurveyResultsResponseFromJSON = exports.instanceOfSurveyResultsResponse = void 0;
var runtime_1 = require("../runtime");
var SurveyResultsByType_1 = require("./SurveyResultsByType");
/**
 * Check if a given object implements the SurveyResultsResponse interface.
 */
function instanceOfSurveyResultsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyResultsResponse = instanceOfSurveyResultsResponse;
function SurveyResultsResponseFromJSON(json) {
    return SurveyResultsResponseFromJSONTyped(json, false);
}
exports.SurveyResultsResponseFromJSON = SurveyResultsResponseFromJSON;
function SurveyResultsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'surveyResults': !(0, runtime_1.exists)(json, 'survey_results') ? undefined : (json['survey_results'].map(SurveyResultsByType_1.SurveyResultsByTypeFromJSON)),
    };
}
exports.SurveyResultsResponseFromJSONTyped = SurveyResultsResponseFromJSONTyped;
function SurveyResultsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'survey_results': value.surveyResults === undefined ? undefined : (value.surveyResults.map(SurveyResultsByType_1.SurveyResultsByTypeToJSON)),
    };
}
exports.SurveyResultsResponseToJSON = SurveyResultsResponseToJSON;
